<div class="list-container">
    <table class="table">
        <thead>
            <tr class="table-header">
                <th id="Type" class="table-header-title text-start">{{'myProfile.addressType' | translate}}</th>
                <th id="Address" class="table-header-title text-center">{{'myProfile.address' | translate}}</th>
            </tr>
        </thead>
        <tbody>
            <ng-container *ngFor="let address of addresses">
                <tr class="row-container">
                    <td HJSuppress id="Type" class="column-content table-main-td text-start">
                        {{address.adressType.value}}
                    </td>
                    <td HJSuppress id="Address" class="column-content text-center">
                        <span HJSuppress class="user-data-item-value">
                            {{ getFormattedAddress(address) }}
                        </span>
                    </td>
                </tr>
            </ng-container>
        </tbody>
    </table>
</div>


